import Vue from 'vue'
import vuePositionSticky from 'vue-position-sticky'

Vue.use(vuePositionSticky)
